import React, { useEffect, useState } from "react";
import { isConnected, userVisitNotiSocket, publishMessage } from "./stompService";

export const CustomerButton = () => {
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    userVisitNotiSocket(); // 메시지 핸들러는 없어도 됨

    const interval = setInterval(() => {
      if (isConnected()) {
        setConnected(true);
        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const notify = () => {
    publishMessage("/api/attendance/customer/arrived", "1212");
  };

  return (
    <button onClick={notify} disabled={!connected}>
      {connected ? "입장 알림 보내기" : "연결 중..."}
    </button>
  );
};
